import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Websites from '../SettingsPage/Websites';
import AddAccount from './AddAccount';
import Logout from './Logout';

const Profile = ({ className }) => {
    const licenses = useSelector(state => state.license.all);
    const nickname = useSelector(state => state.auth.nickname);

    return (
        <div className={className}>
            <h3 className="Profile__Nickname">{nickname}</h3>
            <h4 className="Profile__Title">مدیریت حساب کاربری</h4>
            <Websites websites={licenses} showActive />
            {/* <AddAccount /> */}
            <Logout />
        </div>
    );
};

Profile.propTypes = {
    className: PropTypes.string.isRequired
};

export default styled(Profile)`
    height: calc(100vh - 160px);
    padding: 15px 30px;
    overflow: auto;
    overflow-x: hidden;
    padding-top: 50px;

    .Profile__Nickname {
        font-size: 18px;
        line-height: 31px;
        font-weight: bold;
        color: #0d1fa1;
        margin-bottom: 28px;
    }

    .Profile__Title {
        font-size: 16px;
        line-height: 28px;
        font-weight: bold;
        color: #0d1fa1;
        margin-bottom: 20px;
    }

    ${Websites} {
        > span {
            display: none;
        }

        > div {
            max-width: none;
        }
    }
`;
